import { useSearch } from '@tanstack/react-router'

import { useAppNavbar } from '@/shared/hooks/use-app-navbar'
import { navigateToClientAppCity } from '@/shared/lib/navigate'
import { Button, Icon } from '@/shared/ui'

import styles from './pass-card-bind-success.module.scss'

export const PassCardBindSuccess = () => {
    useAppNavbar(' ', null, null)
    const { cardPanLast4 } = useSearch({ from: '/_protected/pass-card-bind/success' })

    return (
        <div className={styles['pass-card-bind-success']}>
            <div className={styles['pass-card-bind-success-content']}>
                <div className={styles['pass-card-bind-success-content__icon']}>
                    <Icon color='var(--extensions-text-and-icon-success)' icon='check' size={40} />
                </div>
                <span className={styles['pass-card-bind-success-content__title']}>
                    Карта ••{cardPanLast4}
                    <br />
                    успешно добавлена
                </span>
            </div>
            <Button
                className={styles['pass-card-bind-success__button']}
                size='large'
                variant='primary'
                onClick={() => {
                    navigateToClientAppCity()
                }}
            >
                Далее
            </Button>
        </div>
    )
}
